import { Asset, AssetInput, PowerSupply, PowerSupplyInput } from '../types'

export function stripAssetFieldsFromPowerSupplyInput<
  T extends PowerSupplyInput & Record<string, unknown>
>(input: T): Omit<T, 'owner' | 'project' | 'level' | 'lift'> {
  const { owner: _owner, project: _project, level: _level, lift: _lift, ...rest } = input

  return rest
}

export function buildAssetInputFromPowerSupplyInput(
  input: PowerSupplyInput,
  asset: Asset
): AssetInput {
  return {
    name: input.name ?? asset.name,
    description: input.description !== undefined ? input.description : (asset.description ?? null),
    company: input.owner !== undefined ? input.owner : (asset.companyId ?? null),
    project: input.project !== undefined ? input.project : (asset.projectId ?? null),
    level: input.level !== undefined ? input.level : (asset.levelId ?? null),
    lift: input.lift !== undefined ? input.lift : (asset.liftId ?? null)
  }
}

export function withUpdatedPowerSupplyAsset(powerSupply: PowerSupply, asset: Asset): PowerSupply {
  if (powerSupply.device === undefined || powerSupply.device === null) {
    return powerSupply
  }

  return {
    ...powerSupply,
    device: {
      ...powerSupply.device,
      assetId: asset.id,
      asset
    }
  }
}
